import { render, staticRenderFns } from "./orderInvoice.vue?vue&type=template&id=274293f9&scoped=true"
import script from "./orderInvoice.vue?vue&type=script&lang=js"
export * from "./orderInvoice.vue?vue&type=script&lang=js"
import style0 from "./orderInvoice.vue?vue&type=style&index=0&id=274293f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274293f9",
  null
  
)

export default component.exports